const stateYourFinancialSituation = {
	MonthlyGrossIncome: 0
};

const gettersYourFinancialSituation = {
	MonthlyGrossIncome: state => state.MonthlyGrossIncome
};

const mutationsYourFinancialSituation = {
	setMonthlyGrossIncome(state) {
		if (
			state.constants['your_current_savings']
			&& state.constants['your_current_savings'] !== ''
		) {
			state.MonthlyGrossIncome = +state.constants['your_current_savings'] / 12;
		}
		else state.MonthlyGrossIncome = 0;
	}
};

export {
	stateYourFinancialSituation,
	gettersYourFinancialSituation,
	mutationsYourFinancialSituation
};
